import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type {
  OutstandingBalanceState,
  OutstandingBalanceResponse,
} from './types';
import { fetchOutstandingBalance } from './thunk';

const initialState: OutstandingBalanceState = {
  data: null,
  status: 'idle',
  error: null,
};

const outstandingBalanceSlice = createSlice({
  name: 'outstandingBalance',
  initialState,
  reducers: {
    resetOutstandingBalanceState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOutstandingBalance.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(
        fetchOutstandingBalance.fulfilled,
        (state, action: PayloadAction<OutstandingBalanceResponse>) => {
          state.status = 'succeeded';
          state.data = action.payload;
        }
      )
      .addCase(fetchOutstandingBalance.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload ?? 'Failed to load outstanding balance';
      });
  },
});

export const { resetOutstandingBalanceState } = outstandingBalanceSlice.actions;

export default outstandingBalanceSlice.reducer;
